import BrandSlider1 from '../../components/Slider/BrandSlider1'
export default function Brand() {
    return (
        <>
  {/*Brand One Start*/}
  <section className="brand-one">
    <div className="container">
      <BrandSlider1/>
    </div>
  </section>
  {/*Brand One End*/}
</>

    )
}
